import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_candidates_cv_list = async () => {
  const requestObj = {
    path: `api/cv/get`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_cv_against_candidates = async (data) => {
  const requestObj = {
    path: `api/cv/add`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_cv_of_candidate = async (id, data) => {
  const requestObj = {
    path: `api/cv/update/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_cv_against_candidates = async (id) => {
  const requestObj = {
    path: `api/cv/delete/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
